/* @flow */
import Button from 'components/Button.jsx';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import React from 'react';

import cx from 'classnames';
import './styles/GroupMessageHeaderAction.scss';

class GroupMessageHeaderAction extends React.Component {
  static propTypes = {
    color: React.PropTypes.oneOf(['lava', 'brand']),
  };

  static propClasses = {
    color: {
      lava: 'GroupMessageHeaderAction-lava',
      brand: 'GroupMessageHeaderAction-brand',
    },
  };

  static defaultProps = {
    color: 'brand',
  };

  render() {
    return (
      <Button
        className={cx('GroupMessageHeaderAction', getPropClassesFromInstance(this))}
        level="text"
        size="small"
        onClick={this.props.onClick}>
        {this.props.children}
      </Button>
    );
  }
}

export default GroupMessageHeaderAction;



// WEBPACK FOOTER //
// ./src/groups/components/GroupMessageHeaderAction.jsx